import { FunctionComponent, useCallback } from "react";
import { ExternalIcon } from "@icons/ExternalIcon";
import { setOverlayScreenAction } from "@store/app/appReducer";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@store/store";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

import "./WithoutDaysHeader.css";

const WithoutDaysHeader: FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const handleAddDates = useCallback(() => {
    dispatch(
      setOverlayScreenAction({
        name: "PlanDatePicker",
      }),
    );
  }, [dispatch]);

  return (
    <div className="without-days-header-component">
      <div className="add-dates-container">
        <TabButton
          onPress={handleAddDates}
          label={t("screens.plan.addPlanDates") ?? ""}
          variant="outline"
          iconPrefix={
            <ExternalIcon
              size={20}
              color={colors.iconPrimary}
              svgName="calendar"
            />
          }
        />
      </div>
    </div>
  );
};

export { WithoutDaysHeader };
